export default __webpack_public_path__ + "static/media/uploader-tandem-problem-1.1f12a194.png";